import { Component, computed, input } from '@angular/core';
import { ScoutingLinkPipe } from '@web/shared/pipes/scouting-link.pipe';
import { isEmpty } from 'class-validator';
import { ScoutingCodeTagComponent } from '../../scouting-code-tag.component';
import { SearchScoutingEntry } from '../interfaces/search-scouting-entry.interface';
import { DetailItem, SearchItemBaseComponent } from './search-item-base.component';
import { SearchStatusChipComponent } from './search-status-chip.component';

@Component({
  selector: 'app-search-scouting-item',
  imports: [ScoutingCodeTagComponent, ScoutingLinkPipe, SearchItemBaseComponent, SearchStatusChipComponent],
  template: `
    @let _item = item();

    <app-search-item-base
      icon="pi pi-chart-bar"
      color="text-soe-golden-sand"
      [detailRouterLink]="_item | scoutingLink"
      [detailItems]="detailItems()"
    >
      <ng-template #title>
        <div [innerHTML]="_item.name"></div>
      </ng-template>

      <ng-template #codeTag>
        <app-scouting-code-tag [scouting]="_item" [clickable]="false" />
      </ng-template>

      <ng-template #statusChip>
        @if (_item.statusName) {
          <app-search-status-chip
            [name]="_item.statusName"
            [backgroundColor]="_item.statusColor"
            [textColor]="_item.statusTextColor"
          />
        }
      </ng-template>
    </app-search-item-base>
  `,
})
export class SearchScoutingItemComponent {
  readonly item = input.required<SearchScoutingEntry>();

  readonly detailItems = computed<DetailItem[]>(() => {
    const item = this.item();

    return [
      {
        icon: 'pi pi-user',
        content: item.targetName,
        isHtml: true,
      },
      {
        icon: 'pi pi-share-alt',
        content: item.referralName,
        isHtml: true,
      },
    ].filter((v) => !isEmpty(v.content));
  });
}
